// // App.js
// import React, { useState, useEffect } from 'react';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import { CssBaseline, Box, CircularProgress } from '@mui/material';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider, useAuth } from '../src/context/authContext';

// // Components
// import Navbar from './layout/Navbar';
// import Sidebar from './layout/Sidebar';

// // Pages
// import AuthLanding from './pages/auth/Login';
// import OtpLogin from './pages/auth/LoginWithOtp';
// import Dashboard from './pages/Dashboard';
// import AuthRegister from './pages/auth/Register';

// const theme = createTheme({
//   palette: {
//     primary: { main: '#2E5BFF' },
//     secondary: { main: '#00C7BE' },
//     background: { default: '#F4F5F7' }
//   }
// });

// const ProtectedRoute = ({ children }) => {
//   const { userData, loading } = useAuth();

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // Check if user is authenticated via context
//   if (!userData) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

// const PublicRoute = ({ children }) => {
//   const { userData, loading } = useAuth();

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // Check if user is already authenticated
//   if (userData) {
//     return <Navigate to="/dashboard" />;
//   }

//   return children;
// };

// const DashboardLayout = () => {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const { userData } = useAuth();

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <Navbar 
//         user={userData}
//       />
//       <Sidebar 
//         open={sidebarOpen}
//         user={userData}
//       />
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: `calc(100% - ${sidebarOpen ? 280 : 70}px)`,
//           minHeight: '100vh',
//           backgroundColor: '#F4F5F7',
//           ml: `${sidebarOpen ? 280 : 70}px`,
//           pt: '64px'
//         }}
//       >
//         <Routes>
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="*" element={<Navigate to="/dashboard" />} />
//         </Routes>
//       </Box>
//     </Box>
//   );
// };

// function App() {
//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Router>
//         <AuthProvider>
//           <Routes>
//             {/* Public Routes */}
//             <Route path="/login" element={
//               <PublicRoute>
//                 <AuthLanding />
//               </PublicRoute>
//             } />
//             <Route path="/register" element={
//               <PublicRoute>
//                 <AuthRegister />
//               </PublicRoute>
//             } />
//             <Route path="/otp-login" element={
//               <PublicRoute>
//                 <OtpLogin />
//               </PublicRoute>
//             } />

//             {/* Protected Routes */}
//             <Route path="/*" element={
//               <ProtectedRoute>
//                 <DashboardLayout />
//               </ProtectedRoute>
//             } />

//             {/* Default route */}
//             <Route path="/" element={<Navigate to="/dashboard" />} />
//           </Routes>
//         </AuthProvider>
//       </Router>
//     </ThemeProvider>
//   );
// }

// export default App;

// src/App.js
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box, CircularProgress } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/authContext';
import { FlowToggleProvider } from './context/flowToggleContext';
import { Toaster } from 'react-hot-toast';

// Layout Components
import DashboardLayout from './layout/DashboardLayout';

// Auth Pages
import AuthLanding from './pages/auth/Login';
import OtpLogin from './pages/auth/LoginWithOtp';
import AuthRegister from './pages/auth/Register';

import Dashboard from './pages/Dashboard';
import FIRDashboard from './pages/Client/FIR/Dashboard';
import PurchaseCredits from './pages/Client/FIR/PurchaseCredits';
import CreateRequestWizard from './pages/Client/FIR/CreateRequestWizard';
import Calendar from './pages/Calender';
import FIRCalendar from './pages/technical/FIRCalendar';
import Clients from './pages/Clients';
import Engineers from './pages/Engineers';
import WeeklyReports from './pages/WeeklyReports';
import History from './pages/ClientCreditsHistory';
import FIRRequests from './pages/admin/FIRRequests';
import BuyCredits from './pages/Client/BuyCredits';

// Project Pages
import AddSiteCheck from './pages/Projects/AddSiteCheck';
import AllProjects from './pages/Projects/AllProjects';
import UnassignedProjects from './pages/Projects/Unassigned';
import AssignedProjects from './pages/Projects/Assigned';
import CompletedProjects from './pages/Projects/Completed';
import VisitedProjects from './pages/Projects/Visited';
import SignaturePending from './pages/Projects/SignaturePending';
import FinalReports from './pages/Projects/FinalReports';
import ClientCreditHistory from './pages/ClientCreditsHistory';

//progress pages

import Inhouse from './pages/progress/Inhouse';
import MPR from './pages/progress/MPR';
import WMR from './pages/progress/WMR';
import WPR from './pages/progress/WPR';
import DPR from './pages/progress/DPR';
import AddNewProject from './pages/progress/AddNewProject';
import EditReport from './pages/progress/EditReport';
import EditInhouseProject from './pages/progress/EditInhouseProject';
import AddDPR from './pages/progress/AddDPR';
import EditDPR from './pages/progress/EditDPR';
import ViewDPR from './pages/progress/ViewDPR';
import ViewWPR from "./pages/progress/ViewWPR";
import ViewWMR from "./pages/progress/ViewWMR";
import ViewMPR from "./pages/progress/ViewMPR";
import AddWPR from './pages/progress/AddWPR';
import EditWPR from './pages/progress/EditWPR';
import AddWMR from './pages/progress/AddWMR';
import EditWMR from './pages/progress/EditWMR';
import AddMPR from './pages/progress/AddMPR';
import EditMPR from './pages/progress/EditMPR';
import AddMom from './pages/progress/AddMom';
import EditMom from './pages/progress/EditMom';
import ViewMom from './pages/progress/ViewMom';

// Settings Pages
import Checklists from './pages/Settings/Checklists';
//import ExportData from './pages/Settings/ExportData';
import GeneralSettings from './pages/Settings/GeneralSettings';
import ExportData from './pages/Settings/ExportData';
import ManageFIRMappings from './pages/admin/ManageFIRMappings';
import SelfVisitReports from './pages/progress/SelfVisit/SelfVisitReports';
import AddselfVisitReport from './pages/progress/SelfVisit/AddselfVisitReport';
import EditSelfVisitReport from './pages/progress/SelfVisit/EditSelfVisitReport';

// Technical Observation Pages
import TechnicalDashboard from './pages/technical/Dashboard';
import TechnicalObservations from './pages/technical/Observations';
import TechnicalReports from './pages/technical/Reports';
import TechnicalSettings from './pages/technical/Settings';
import TechnicalAddNewProject from './pages/technical/AddNewProject';
import TechnicalStartMapping from './pages/technical/StartMapping';
import ManageDummyStats from "./pages/technical/ManageDummyStats";
import TechnicalMapping from './pages/technical/MappingScreen';
import FIRCreditHistory from './pages/technical/FIRCreditHistory';
import TechnicalViewMapping from './pages/technical/ViewMapping';
import InProgressProjects from './pages/technical/InProgressProjects';
import CompletedTechincalProjects from './pages/technical/CompletedProjects';
import ProjectDetails from './pages/technical/ProjectDetails';
import ReportDetailView from './pages/technical/ReportDetailView';
import EditFIRRequest from './pages/admin/EditFIRRequest';
import TechnicalEngineers from './pages/technical/Engineers';

const theme = createTheme({
  palette: {
    primary: { main: '#421A6E' },
    secondary: { main: '#652D90' },
    error: { main: '#EF4444' },
    warning: { main: '#F59E0B' },
    info: { main: '#3B82F6' },
    success: { main: '#10B981' },
    background: { default: '#F4F5F7' }
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
});

const ProtectedRoute = ({ children }) => {
  const { userData, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!userData) {
    return <Navigate to="/login" />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { userData, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (userData) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

const RoleBasedDashboard = () => {
  const { userData } = useAuth();
  if (userData?.clientRole?.roleType === 'Individual') {
    return <FIRDashboard />;
  }
  return <Dashboard />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <FlowToggleProvider>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={
                <PublicRoute>
                  <AuthLanding />
                </PublicRoute>
              } />
              <Route path="/register" element={
                <PublicRoute>
                  <AuthRegister />
                </PublicRoute>
              } />
              <Route path="/otp-login" element={
                <PublicRoute>
                  <OtpLogin />
                </PublicRoute>
              } />

              {/* Protected Routes with Dashboard Layout */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <RoleBasedDashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/fir/purchase" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <PurchaseCredits />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/fir/create-wizard" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <CreateRequestWizard />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/calendar" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Calendar />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/history" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ClientCreditHistory />
                  </DashboardLayout>
                </ProtectedRoute>

              } />
              <Route path="/clients" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Clients />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/engineers" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Engineers />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/weekly-reports" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <WeeklyReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              {/* {Progress routes} */}
              <Route path="/progress/inhouse" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Inhouse />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/mpr" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <MPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />

              <Route path="/progress/wmr" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <WMR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/wpr" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <WPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />

              <Route path="/progress/dpr" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <DPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/add-inhouse-project" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddNewProject />
                  </DashboardLayout>
                </ProtectedRoute>
              }

              />
              <Route path="/progress/add-dpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddDPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-dpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditDPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/view-dpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ViewDPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/view-wpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ViewWPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/view-mpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ViewMPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/view-wmr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ViewWMR />
                  </DashboardLayout>

                </ProtectedRoute>
              }
              />
              <Route path="/progress/add-wpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddWPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-wpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditWPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/add-wmr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddWMR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-wmr/:projectId/:wmrId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditWMR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/add-mpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddMPR />
                  </DashboardLayout>

                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-mpr/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditMPR />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/add-mom/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddMom />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-mom/:projectId/:momId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditMom />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/view-mom/:projectId/:momId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ViewMom />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-inhouse-project/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditInhouseProject />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/progress/edit-report/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditReport />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/self-visit-reports" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SelfVisitReports />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/self-visit-reports/add" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddselfVisitReport />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              <Route path="/self-visit-reports/edit/:reportId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditSelfVisitReport />
                  </DashboardLayout>
                </ProtectedRoute>
              }
              />
              {/* Project Routes */}
              <Route path="/projects/all" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AllProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/fir-requests" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <FIRRequests />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/buy-credits" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <BuyCredits />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/add-site-check" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AddSiteCheck />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/unassigned" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <UnassignedProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/assigned" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AssignedProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/completed" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <CompletedProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/visited" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <VisitedProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/signature-pending" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <SignaturePending />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/projects/final-reports" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <FinalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              {/* Settings Routes */}
              <Route path="/settings/checklists" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Checklists />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/settings/export" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ExportData />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/settings/export" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ExportData />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/credits" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <FIRCreditHistory />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/settings/general" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <GeneralSettings />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              {/* Technical Observation Routes */}
              <Route path="/technical/dashboard" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalDashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/clients" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Clients />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/engineers" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalEngineers />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/settings/dummy-stats" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ManageDummyStats />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/calendar" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <FIRCalendar />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/all" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/pending" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/approved" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/rejected" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/my" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/create" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/draft" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/admin/fir-mappings/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalMapping />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/admin/fir-requests/edit/:id" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <EditFIRRequest />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/observations/submitted" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalObservations />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/reports/daily" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/reports/weekly" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/reports/monthly" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/reports/my" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/reports/create" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalReports />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/settings/checklists" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalSettings />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/settings/templates" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalSettings />
                  </DashboardLayout>
                </ProtectedRoute>
              } />

              <Route path="/technical/settings/general" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalSettings />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/settings/manage-fir-mappings" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ManageFIRMappings />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/add-project" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalAddNewProject />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/start-mapping/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalStartMapping />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/mapping/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalMapping />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/view-mapping/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <TechnicalViewMapping />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/projects/in-progress" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <InProgressProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/project-details/:projectId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ProjectDetails />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/report/:reportId" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <ReportDetailView />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              <Route path="/technical/projects/completed" element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <CompletedTechincalProjects />
                  </DashboardLayout>
                </ProtectedRoute>
              } />
              {/* Default routes */}
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </AuthProvider>
        </FlowToggleProvider>
      </Router>
      <Toaster position="top-right" reverseOrder={false} />
    </ThemeProvider>
  );
}

export default App;